import {createSlice} from "@reduxjs/toolkit";

const initFilePreviewObj = {
    name: "",
    path: "",
    data: null,
    size: 0, // In MB
}

const initialState = {
    currentPath: "/",
    currentPathLocked: false,
    dirData: [],
    lastDirDataERP: [], // For breadcrumb displayName mapping in ERP objects
    previewFile: initFilePreviewObj,
    extraData: {
        spaceUsed: 0,
        cloudSpace: 0,
        cloudMaximumFileSize: 0,
        specialCode: "0",
    },
    copyFilePath: "",
    copyFileCut: false,
    copyFolderPath: "",
    copyFolderCut: false,

    autoPreview: "", // File to auto open preview on window load.
    autoDir: "", // Dir to auto open
    searchKeyword: "",

    specialCodeWas1: false,
    wasInMiniCloud: false,

    // Tree View
    openPaths: [],
    treeData: [{
        item: "/",
        displayName: "Αρχική",
        folder: true,
        fileCount: 0,
        hasSubfolders: true,
        content: [],
    }],

    // Emron functionalities
    disableCloudPage: false,
    disableEmronRegisterPage: false,

    saleMarkFromCloud: "",
    buyMarkFromCloud: "",
}

export const CloudSlice = createSlice({
    name: "cloud-slice",
    initialState,
    reducers: {
        setCurrentPath: (state, {payload}) => {
            state.currentPath = payload;
        },
        setCurrentPathLocked: (state, {payload}) => {
            state.currentPathLocked = payload;
        },
        setDirData: (state, {payload}) => {
            if (state.dirData && String(state.currentPath).startsWith("/ERP") && String(state.currentPath).split("/").length === 3) {
                state.lastDirDataERP = state.dirData;
            }
            state.dirData = payload;
        },
        setPreviewFile: (state, {payload}) => {
            if (state.previewFile.data) URL.revokeObjectURL(state.previewFile.data); // Clear last blob preview from browser memory
            state.previewFile = payload;
        },
        resetPreviewFile: (state) => {
            if (state.previewFile.data) URL.revokeObjectURL(state.previewFile.data); // Clear last blob preview from browser memory
            state.previewFile = {...initFilePreviewObj};
        },
        setExtraData: (state, {payload}) => {
            state.extraData = payload;
            if (payload?.specialCode === "1" && !state.specialCodeWas1) state.specialCodeWas1 = true;
        },
        setCopyFilePath: (state, {payload}) => {
            state.copyFilePath = payload;
        },
        setCopyFileCut: (state, {payload}) => {
            state.copyFileCut = payload;
        },
        setCopyFolderPath: (state, {payload}) => {
            state.copyFolderPath = payload;
        },
        setCopyFolderCut: (state, {payload}) => {
            state.copyFolderCut = payload;
        },
        setAutoPreview: (state, {payload}) => {
            state.autoPreview = payload;
        },
        setSearchKeyword: (state, {payload}) => {
            state.searchKeyword = payload;
        },
        setAutoDir: (state, {payload}) => {
            state.autoDir = payload;
        },

        // Tree View
        setOpenPaths: (state, {payload}) => {
            state.openPaths = payload;
        },
        setTreeData: (state, {payload}) => {
            state.treeData = payload;
        },

        // Emron functionalities
        setDisableCloudPage: (state, {payload}) => {
            state.disableCloudPage = payload;
        },
        setDisableEmronRegisterPage: (state, {payload}) => {
            state.disableEmronRegisterPage = payload;
        },

        setSaleMarkFromCloud: (state, {payload}) => {
            state.saleMarkFromCloud = payload;
        },
        setBuyMarkFromCloud: (state, {payload}) => {
            state.buyMarkFromCloud = payload;
        },

        setWasInMiniCloud: (state, {payload}) => {
            state.wasInMiniCloud = payload;
        },
    }
})

export const {
    setCurrentPath,
    setCurrentPathLocked,
    setDirData,
    setPreviewFile,
    resetPreviewFile,
    setExtraData,
    setCopyFilePath,
    setCopyFileCut,
    setCopyFolderPath,
    setCopyFolderCut,
    setAutoPreview,
    setSearchKeyword,
    setAutoDir,

    // Tree View
    setOpenPaths,
    setTreeData,

    // Emron functionalities
    setDisableCloudPage,
    setDisableEmronRegisterPage,

    setSaleMarkFromCloud,
    setBuyMarkFromCloud,

    setWasInMiniCloud,
} = CloudSlice.actions;
